import { render, staticRenderFns } from "./CollapsibleFieldset.vue?vue&type=template&id=42f9dcfc&scoped=true&"
import script from "./CollapsibleFieldset.vue?vue&type=script&lang=js&"
export * from "./CollapsibleFieldset.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleFieldset.vue?vue&type=style&index=0&id=42f9dcfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f9dcfc",
  null
  
)

export default component.exports